<template>
    <div>
        <div class="module-container">
            <div class="card-status-center">
                <card-status></card-status>
            </div>

            <div class="col-md-8">
                <div class="cards-container">
                    <card-realtime v-for="op in operators" :key="op.id" :id="op.id" :nome="op.nome"
                        :extension="op.extension_line" :status="userStatus" :userQueues="op.queues"></card-realtime>
                </div>
            </div>

            <div class="col-md-4">
                <calls-queue />
                <total-calls />
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import cardRealtime from './CardRealtime.vue';
import callsQueue from './CallsinQueue';
import totalCalls from './TotalCalls';
let { realtime } = require("../../modules/realtime/connectionRealtime");

export default {
    components: {
        cardRealtime,
        callsQueue,
        totalCalls
    },
    data() {
        return {
            operators: [],
            // connection: {},
            queueStatus: [],
            userName: user.getName(),
            userExtension: user.getExtension()
        }
    },
    methods: {
        groupQueues() {
            this.queueStatus = [];
        },
        setupSocketConnection() {
            const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
	    console.log('parsedTelefone', parsedTelefone)
            if (parsedTelefone) {
		    realtime = io.connect(`${process.env.MIX_APP_URL}:3023/realtimeModule`, {
                    reconnection: true,
                    reconnectionDelay: 2000,
                    reconnectionDelayMax: 10000,
                    randomizationFactor: 0.5,
                    pingTimeout: 600000,
                    pingInterval: 120000,
                    query: {
                        origin: `App do realtime: User -  ${this.userName} | Extension - ${this.userExtension}`, // Identificador do componente ou origem
                    }
                });

                realtime.on('connect', () => {
                    console.info('Conectado ao serviço do realtime');
                    realtime.emit('QueueStatus');
                });

                realtime.on('disconnect', (reason) => {
                    console.info(`Desconectado: ${reason}`);
                });

                realtime.on('reconnect_attempt', (attemptNumber) => {
                    console.info(`Tentativa de reconexão #${attemptNumber}`);
                });
            } else {
                realtime = {
                    on: function () { },
                    emit: function () { }
                };
            }
        }
    },
    created() {
        this.setupSocketConnection();
        axios.get('/realtime/listUsersPhone').then(({ data }) => {
            this.operators = data;
        });

        this.userStatus = 'Deslogado';
    },
    mounted() {
        realtime.emit('QueueStatus');
        // setInterval(() => {
        //     setTimeout(async () => {
        //         connection = {
        //             on: function () { },
        //             emit: function () { }
        //         };
        //         this.setupSocketConnection();
        //         realtime.emit('QueueStatus');
        //     }, 1000)
        // }, 300000); //5 MINUTOS
    },
}
</script>

<style scoped>
.module-container {
    display: flex;
    flex-wrap: wrap;
}

.cards-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.card-status-center {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
